import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-vertical-steps',
  templateUrl: './vertical-steps.component.html',
  styleUrls: ['./vertical-steps.component.css']
})
export class VerticalStepsComponent {
  @Input() data!:any;
}
